
import { mapState } from 'vuex';

export default {
  i18nComponentKey: 'WidgetProductReviewsStatistics.components.ChartBase',
  props: {
    statisticsData: { type: Array, default: () => [] }
  },
  computed: {
    ...mapState('widget', ['widget'])
  },
  methods: {
    displayTopOption(topRatedOption) {
      const { name, percentage } = topRatedOption;
      return name && percentage ? `${name} ${percentage}%` : '-';
    },
    getIconName(value) {
      // 10 ~ 19: Smiley, 20 ~ 29: Neutral, 30 ~ 39: Sad
      const range = Math.floor(value / 10);
      switch (range) {
        case 1:
          return 'xi-emoticon-smiley-o';
        case 2:
          return 'xi-emoticon-neutral-o';
        case 3:
          return 'xi-emoticon-sad-o';
      }
      return 'xi-emoticon-smiley-o';
    }
  }
};
